module.exports = __webpack_public_path__ + "static/reactday-9d2f61d11ea8b78af44e2ec6d0a0da32.jpeg";